import AWS from 'aws-sdk/global';
import 'aws-sdk/lib/credentials/cognito_identity_credentials';
import {
  CognitoUserPool,
  CognitoUserAttribute,
  CognitoUser,
  AuthenticationDetails
} from 'amazon-cognito-identity-js';

import store from '@/store';

export default class Cognito {
  /**
   * コンストラクタ
   */
  constructor() {
    const customize = store.state.system.customize;
    AWS.config.region = customize.cognito.region;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: customize.cognito.pool_id,
    });
    this.poolData = {
      UserPoolId: customize.cognito.user_pool_id,
      ClientId: customize.cognito.client_id
    };
    this.userPool = new CognitoUserPool(this.poolData);
  }
  /**
   * ユーザー登録
   * @param {Object} formValue 登録用のフォームオブジェクト
   */
  signup(formValue) {
    return new Promise((resolve, reject) => {
      const attributeList = [];
      const dataName = {
        Name: 'email',
        Value: formValue.email,
      };
      const attributeName = new CognitoUserAttribute(dataName);
      attributeList.push(attributeName);

      this.userPool.signUp(
        formValue.userId,
        formValue.password,
        attributeList,
        null,
        (err) => {
          if (err) {
            reject(err);
          }
          resolve();
        });
    });
  }

  /**
   * 認証コードを用いたアカウント認証処理
   * @param {string} userId メールアドレスとサイトIDから生成されたID
   * @param {string} verificationCode 認証コード
   */
  activate(userId, verificationCode) {
    return new Promise((resolve, reject) => {
      const userData = {
        Username: userId,
        Pool: this.userPool
      };
      const cognitoUser = new CognitoUser(userData);

      // 認証処理
      cognitoUser.confirmRegistration(verificationCode, false, function(err, result) {
        if (err) {
          reject(err);
        }
        resolve();
      });
    });
  }

  /**
   * ログイン処理
   * @param {string} userId メールアドレスとサイトIDから生成されたID
   * @param {string} password パスワード
   */
  login(userId, password) {
    return new Promise((resolve, reject) => {
      const authDetail = new AuthenticationDetails({
        Username: userId,
        Password: password
      });
      const cognitoUser = new CognitoUser({
        Username: userId,
        Pool: this.userPool,
      });

      cognitoUser.authenticateUser(authDetail, {
        onSuccess: (result) => {
          resolve(result);
        },
        onFailure: (err) => {
          reject(err);
        },
      });
    });
  }

  /**
   * ログイン判定
   */
  isAuthenticated() {
    return new Promise((resolve, reject) => {
      const cognitoUser = this.userPool.getCurrentUser();
      if (!cognitoUser) reject(cognitoUser);
      cognitoUser.getSession((err, session) => {
        if (err) reject(err);
        if (!session.isValid()) reject(session);
        resolve(session);
      });
    });
  }

  /**
   * ログアウト
   */
  signOut() {
    const cognitoUser = this.userPool.getCurrentUser();
    if (!cognitoUser) return;
    cognitoUser.signOut();
  }

  /**
   * パスワードリセット
   */
  forgotPassword(userId) {
    return new Promise((resolve, reject) => {
      const cognitoUser = new CognitoUser({
        Username: userId,
        Pool: this.userPool,
      });

      cognitoUser.forgotPassword({
        onSuccess: (result) => { resolve(result); },
        onFailure: (err) => { reject(err); }
      });
    });
  }

  /**
   * パスワードリセット（検証コード確認）
   */
  confirmForgotPassword(verificationCode, newPassword, userId) {
    return new Promise((resolve, reject) => {
      const cognitoUser = new CognitoUser({
        Username: userId,
        Pool: this.userPool,
      });

      cognitoUser.confirmPassword(verificationCode, newPassword, {
        onSuccess: (result) => { resolve(result); },
        onFailure: (err) => { reject(err); }
      });
    });
  }

  /**
   * ユーザーアカウントを削除
   */
  deleteUser(userId) {
    return new Promise((resolve, reject) => {
      const cognitoUser = this.userPool.getCurrentUser();
      if (cognitoUser) {
        cognitoUser.getSession((err, session) => {
          if (err) {
            reject(err);
          } else {
            cognitoUser.deleteUser((deleteErr, result) => {
              if (deleteErr) {
                reject(err);
              }
              resolve(result);
            });
          }
        });
      }
    });
  }
}
